import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./query/query-client";
import { PolarisProvider } from "./providers/PolarisProvider.jsx";
import { RouterProvider } from "react-router-dom";
import { router } from "./router.tsx";

export default function App() {
  return (
    <PolarisProvider>
      <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      </QueryClientProvider>
    </PolarisProvider>
  );
}
